// assets/edm-bundle-config.js
// Konfiguration: Konstanten, Selektoren, Defaults, Texte

window.EdumonBundle = window.EdumonBundle || {};

window.EdumonBundle.Config = {
  // ================== SELECTORS ==================
  SELECTORS: {
    // Main Elements
    BUNDLE_BUILDER: '#bundle-builder',
    STICKY_BUYME: '#sticky-buyme',
    STICKY: '#bb-sticky',
    SHEET: '#bb-sheet',
    SHEET_GLOBAL: '#bb-sheet-global',
    SHEET_PANEL: '.bb-sheet__panel',
    SHEET_GRID: '.bb-sheet__grid',
    SCrim: '#bb-scrim',
    SCrim_GLOBAL: '#bb-scrim-global',
    MODAL: '#bb-modal',
    MODAL_GLOBAL: '#bb-modal-global',
    MOBILE_LOADING: '#bb-mobile-loading',
    
    // Cart Elements
    CART_NOTIFICATION: 'cart-notification',
    CART_DRAWER: 'cart-drawer',
    CART_ITEMS: '.cart-item',
    CART_DRAWER_ITEMS: 'cart-drawer-items',
    CART_ITEMS_ROOT: '#CartDrawer-CartItems',
    CART_CHECKOUT_BTN: '#CartDrawer-Checkout',
    
    // Bundle Builder Elements
    SLOTS: '.bb__slot',
    CARDS: '.bb__card',
    CARD_MEDIA: '[data-bb-card]',
    HINT: '[data-bb-hint]',
    TOTAL_QTY: '[data-bb-total-qty]',
    ESTIMATED: '[data-bb-estimated]',
    SUBMIT: '[data-bb-submit]',
    LABEL: '[data-bb-label]',
    TAG: '[data-bb-tag]',
    SHOUT: '[data-bb-shout]',
    BADGE: '[data-bb-badge]',
    SLOT_IMG: 'img[data-bb-slot-img]',
    
    // Sheet Elements
    SHEET_COUNT: '[data-bb-sheet-count], [data-bb-sheet-count-global]',
    SHEET_NEXT: '[data-bb-sheet-next], [data-bb-sheet-next-global]',
    SHEET_SUMMARY: '[data-bb-sheet-summary]',
    MILESTONES: '[data-bb-milestones], [data-bb-milestones-global]',
    MILESTONE_CHIP: '.bb-milestones .bb-chip',
    TILE: '.bb-tile',
    TILE_IMGWRAP: '.bb-tile__imgwrap',
    TILE_INFO: '.bb-tile__info',
    BTN_ADD: '.bb-btn-add',
    STEPPER: '.bb-stepper',
    STEPPER_PLUS: '[data-bb-plus]',
    STEPPER_MINUS: '[data-bb-minus]',
    STEPPER_QTY: '[data-bb-qty]',
    
    // Buttons
    CLOSE: '[data-bb-close], [data-bb-close-global]',
    RESET: '[data-bb-reset], [data-bb-reset-global]',
    COMMIT: '[data-bb-commit], [data-bb-commit-global]',
    COMMIT_MODAL: '[data-bb-commit-modal-global], [data-bb-commit]',
    OPEN: '[data-bb-open]',
    EXPRESS_BUNDLE: '[data-bb-express-bundle]',
    MODAL_CLOSE: '[data-bb-modal-close-global], [data-bb-modal-close]',
    
    // Forms
    PRODUCT_FORM: 'form[action^="/cart/add"]',
    ATC_BUTTON: 'button[name="add"], [type="submit"]',
    LOADING_SPINNER: '.loading-overlay__spinner',
    
    // Sticky Elements
    STICKY_FILL: '.bb-sticky__fill',
    STICKY_TEXT: '[data-bb-sticky-text]',
    STICKY_TICKS: '[data-bb-ticks]',
    OPEN_PICKER: '.bb__open-picker',
    
    // Headers
    HEADER: 'header',
    STICKY_HEADER: 'sticky-header',
    HEADER_WRAPPER: '.header-wrapper',
    HEADER_HEADING: '.header__heading',
    HEADER_LOGO: '.header__heading img, .header__heading-logo, .site-header__logo-image, img[alt*="Logo"]',
    
    // Main Content
    MAIN_CONTENT: '#MainContent',
    
    // Triggers
    TRIGGER: '[data-bb-trigger]',
    TRIGGER_SHEET: '[data-bb-trigger="sheet"]',
    TRIGGER_MODAL: '[data-bb-trigger="modal"]',
    LEGACY_TRIGGER: '[data-open-mobile-sheet="true"], [data-one-click="true"]',
    
    // Templates
    SHEET_TEMPLATE: (productId) => `#bb-sheet-template-${productId}`,
    PAYLOAD_TEMPLATE: (productId) => `#bb-payload-${productId}`
  },
  
  // ================== CONSTANTS ==================
  CONSTANTS: {
    MAX_SLOTS: 10,
    FAST_OPEN_MS: 350,
    MIN_LOADING_MS: 350,
    MOBILE_BREAKPOINT: 989,
    MAX_RETRIES: 2,
    VERIFICATION_MAX_ATTEMPTS: 40,
    VERIFICATION_INTERVAL_MS: 50,
    PRELOAD_IMAGE_LIMIT: 8,
    ANIMATION_DURATION_MS: 420,
    CLOSE_ANIMATION_TIMEOUT_MS: 500,
    SCrim_HIDE_DELAY_MS: 250,
    LOGO_RECALC_DELAY_MS: 200,
    DEBOUNCE_DELAY_MS: 160,
    MUTATION_OBSERVER_DELAY_MS: 180
  },
  
  // ================== DEFAULTS ==================
  // Context7: SOT - Single default tiers definition (matches PDP edm-bundle-builder.liquid)
  DEFAULTS: {
    TIERS: [
      {qty: 3, off: 10},
      {qty: 6, off: 15},
      {qty: 10, off: 20}
    ],
    // TIERS_ALTERNATIVE removed - use TIERS as single source of truth
    MONEY_FORMAT: '{{ amount }}',
    MONEY_FORMAT_EURO: '€{{amount}}',
    THUMB_SIZE: '160x160_crop_center',
    PLACEHOLDER_IMAGE: 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif'
  },
  
  // ================== TEXTS ==================
  TEXTS: {
    HINT_EMPTY: 'Klickt auf die Karten, um Booster hinzuzufügen oder zu entfernen. <br/> Wenn ihr fertig seid, legt eure Auswahl <strong>in den Warenkorb</strong>.',
    HINT_EMPTY_DIRTY: 'Ihr habt alle Booster wieder abgewählt. <br/> Änderungen noch nicht übernommen – zum Bestätigen bitte <strong>in den Warenkorb legen</strong>.',
    HINT_IN_CART: (qty) => `Ihr habt <strong>${qty}</strong> Booster in eurem Warenkorb.`,
    HINT_DIRTY: 'Änderungen noch nicht übernommen – zum Bestätigen bitte <strong>in den Warenkorb legen</strong>.',
    TIER_ACTIVE: (off) => `<strong>${off}% Rabatt</strong> auf alle ausgewählten Booster aktiviert.`,
    TIER_NEXT: (needed, off) => `<strong>Noch ${needed} Booster für ${off}% Rabatt.</strong>`,
    TIER_REACHED: (off) => `−${off}% erreicht`,
    TIER_MAX: 'max. Vorteil erreicht',
    COUNT_FORMAT: (current, max) => `${current}/${max}`,
    NEXT_TIER_FORMAT: (needed, off) => `noch ${needed} bis −${off}%`,
    LOADING_TEXT: 'Bundle wird erstellt …',
    LOADING_TEXT_ALT: 'Booster wird gemischt …',
    ERROR_NO_ITEMS: 'Bitte wählen Sie mindestens einen Booster aus.',
    ERROR_LOAD_PRODUCT: 'Fehler beim Laden der Produktdaten: ',
    ERROR_ADD_CART: 'Fehler beim Hinzufügen zum Warenkorb',
    ERROR_INIT_SHEET: 'Fehler: Bottom Sheet konnte nicht initialisiert werden. Bitte Seite neu laden.',
    ERROR_INIT_MODAL: 'Fehler: Modal konnte nicht initialisiert werden. Bitte Seite neu laden.',
    ARIA_SLOT_EMPTY: (idx) => `Slot ${idx} leer`,
    ARIA_SLOT_FILLED: (idx) => `Slot ${idx} belegt`,
    ARIA_TIER_REACHED: (off, qty) => `−${off}% erreicht bei ${qty} Artikeln`
  },
  
  // ================== CSS CLASSES ==================
  CLASSES: {
    HAS_BUNDLE_BUILDER: 'has-bundle-builder',
    MOBILE_ACTIVE: 'bb--mobile-active',
    LOCK: 'bb--lock',
    SHEET_OPEN: 'bb--sheet-open',
    MODAL_OPEN: 'bb--modal-open',
    FREEZE_HEADER: 'bb--freeze-header',
    FILLED: 'is-filled',
    DISABLED: 'is-disabled',
    VISIBLE: 'is-visible',
    OPEN: 'is-open',
    CLOSING: 'is-closing',
    LOADING: 'loading',
    HIDDEN: 'hidden',
    PULSE: 'is-pulse',
    OUT: 'is-out',
    ACTIVE: 'is-active',
    TIER_CURRENT: 'is-tier-current',
    TIER_REACHED: 'is-tier-reached',
    JUST_EARNED: 'just-earned',
    EMPTY: 'is-empty'
  },
  
  // ================== DATA ATTRIBUTES ==================
  DATA_ATTRS: {
    BB_INIT: 'data-bb-init',
    ACTIVE_BUNDLE_KEY: 'data-active-bundle-key',
    CART_DIRTY: 'data-cart-dirty',
    VARIANT_ID: 'data-variant-id',
    VARIANT_PRICE: 'data-variant-price',
    PRODUCT_ID: 'data-product-id',
    PRODUCT_HANDLE: 'data-product-handle',
    QTY: 'data-qty',
    SLOT: 'data-slot',
    SLOT_IMG: 'data-bb-slot-img',
    M: 'data-m',
    BB_STEPPER_ATTACHED: 'data-bb-stepper-attached',
    BB_BUTTONS_ATTACHED: 'data-bb-buttons-attached',
    BB_GLOBAL_HANDLERS_ATTACHED: 'data-bb-global-handlers-attached',
    BB_CONTROLLER_ATTACHED: 'data-bb-controller-attached',
    BB_SCROLL_Y: 'data-bb-scroll-y',
    BB_OUT_TOKEN: 'data-bb-out-token',
    BB_PREV_POS: 'data-bb-prev-pos',
    BB_PREV_LEFT: 'data-bb-prev-left',
    BB_PREV_RIGHT: 'data-bb-prev-right',
    BB_PREV_TRANSFORM: 'data-bb-prev-transform',
    BB_PREV_MARGIN: 'data-bb-prev-margin'
  },
  
  // ================== CSS VARIABLES ==================
  CSS_VARS: {
    LOGO_X: '--bb-logo-x',
    LOGO_W: '--bb-logo-w',
    LOGO_H: '--bb-logo-h',
    HEADER_H: '--bb-header-h',
    PAD_LEFT: '--bb-pad-left',
    PAD_RIGHT: '--bb-pad-right',
    STICKY_TOP_OFFSET: '--sticky-top-offset'
  },
  
  // ================== API ROUTES ==================
  ROUTES: {
    CART_JS: '/cart.js',
    CART_UPDATE_JS: '/cart/update.js',
    CART_ADD_JS: '/cart/add.js',
    CART_CHANGE_JS: '/cart/change.js',
    PRODUCTS_JS: (handle) => `/products/${handle}.js`,
    SECTIONS: (sections) => `/?sections=${encodeURIComponent(sections.join(','))}`
  },
  
  // ================== INIT FLAGS ==================
  INIT_FLAGS: {
    GLOBAL_INITIALIZED: '_bbGlobalInitialized',
    EVENT_DELEGATION_SETUP: '_bbEventDelegationSetup',
    STICKY_BUYME_BOOTED: '__stickyBuymeBooted'
  }
};

